export enum IDP_APPS {
  BOOK_WIDGET = 'BOOK_WIDGET',
  HEADER = 'HEADER'
}

export enum EndpointKeys {
  BOOK_WIDGET_AEM_URL = 'BOOK_WIDGET_AEM_URL',
  GEO_LOCATION_URL = 'GEO_LOCATION_URL',
  CATALOG_API_URL = 'CATALOG_API_URL',
  DEFAULT_LOOKUP_API_URL = 'DEFAULT_LOOKUP_API_URL',
  RETRIEVE_SEARCH_OW_RT = 'RETRIEVE_SEARCH_OW_RT',
  RETRIEVE_SEARCH_MC = 'RETRIEVE_SEARCH_MC',
  SAVED_SEARCH = 'SAVED_SEARCH',
  UPDATE_SEARCH = 'UPDATE_SEARCH',
  SAVE_SLIM_NAV_DETAILS_URL = 'SAVE_SLIM_NAV_DETAILS_URL',
  EDOCS_LINK_SRC = 'EDOCS_LINK_SRC',
  APP_CONFIGURATIONS = 'APP_CONFIGURATIONS',
  APP_NEW_PREDICTIVE_API_URL = 'APP_NEW_PREDICTIVE_API_URL'
}
export enum Redirect_search_routes {
  ADVANCE_SEARCH = 'ADVANCE_SEARCH',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  FLEXIBLE_DATES = 'FLEXIBLE_DATES',
  FLEXIBLE_CALENDAR = 'FLEXIBLE_CALENDAR',
  FLEXIBLE_AIRPORTS = 'FLEXIBLE_AIRPORTS'
}
